// @ts-nocheck
import { UPDATE_SUPPORT_CONTACT_ERROR, UPDATE_SUPPORT_CONTACT_LOADING, UPDATE_SUPPORT_CONTACT_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const UpdateSupportContactReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SUPPORT_CONTACT_LOADING:
            return Object.assign({}, state, { loading: true })
        case UPDATE_SUPPORT_CONTACT_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case UPDATE_SUPPORT_CONTACT_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

